<template>
    
</template>
<script setup> 
import {defineProps, ref, computed } from 'vue'
import {useStore} from 'vuex'
const store = useStore();
</script>